/* jshint sub: true */
exports['bg'] = require('./bg.js');
exports['cs-CZ'] = require('./cs-CZ.js');
exports['da-DK'] = require('./da-DK.js');
exports['de-AT'] = require('./de-AT.js');
exports['de-CH'] = require('./de-CH.js');
exports['de-DE'] = require('./de-DE.js');
exports['de-LI'] = require('./de-LI.js');
exports['el'] = require('./el.js');
exports['en-AU'] = require('./en-AU.js');
exports['en-GB'] = require('./en-GB.js');
exports['en-IE'] = require('./en-IE.js');
exports['en-NZ'] = require('./en-NZ.js');
exports['en-ZA'] = require('./en-ZA.js');
exports['es-AR'] = require('./es-AR.js');
exports['es-CL'] = require('./es-CL.js');
exports['es-CO'] = require('./es-CO.js');
exports['es-CR'] = require('./es-CR.js');
exports['es-ES'] = require('./es-ES.js');
exports['es-NI'] = require('./es-NI.js');
exports['es-PE'] = require('./es-PE.js');
exports['es-PR'] = require('./es-PR.js');
exports['es-SV'] = require('./es-SV.js');
exports['et-EE'] = require('./et-EE.js');
exports['fa-IR'] = require('./fa-IR.js');
exports['fi-FI'] = require('./fi-FI.js');
exports['fil-PH'] = require('./fil-PH.js');
exports['fr-CA'] = require('./fr-CA.js');
exports['fr-CH'] = require('./fr-CH.js');
exports['fr-FR'] = require('./fr-FR.js');
exports['he-IL'] = require('./he-IL.js');
exports['hu-HU'] = require('./hu-HU.js');
exports['id'] = require('./id.js');
exports['it-CH'] = require('./it-CH.js');
exports['it-IT'] = require('./it-IT.js');
exports['ja-JP'] = require('./ja-JP.js');
exports['ko-KR'] = require('./ko-KR.js');
exports['lv-LV'] = require('./lv-LV.js');
exports['nb-NO'] = require('./nb-NO.js');
exports['nb'] = require('./nb.js');
exports['nl-BE'] = require('./nl-BE.js');
exports['nl-NL'] = require('./nl-NL.js');
exports['nn'] = require('./nn.js');
exports['pl-PL'] = require('./pl-PL.js');
exports['pt-BR'] = require('./pt-BR.js');
exports['pt-PT'] = require('./pt-PT.js');
exports['ro-RO'] = require('./ro-RO.js');
exports['ro'] = require('./ro.js');
exports['ru-RU'] = require('./ru-RU.js');
exports['ru-UA'] = require('./ru-UA.js');
exports['sk-SK'] = require('./sk-SK.js');
exports['sl'] = require('./sl.js');
exports['sr-Cyrl-RS'] = require('./sr-Cyrl-RS.js');
exports['sv-SE'] = require('./sv-SE.js');
exports['th-TH'] = require('./th-TH.js');
exports['tr-TR'] = require('./tr-TR.js');
exports['uk-UA'] = require('./uk-UA.js');
exports['zh-CN'] = require('./zh-CN.js');
exports['zh-MO'] = require('./zh-MO.js');
exports['zh-SG'] = require('./zh-SG.js');
exports['zh-TW'] = require('./zh-TW.js');


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/numbro/languages/index.js
// module id = 2125
// module chunks = 0